<script setup lang="ts">
// Vendor
import { object, string } from "zod";
import type { RouteLocationRaw } from "vue-router";

// Constants
import { SALESFORCE_FORM_TYPE } from "@citizenm/salesforce/constants/form";

// Components
// TODO: remove this import when legacy FormRow component is removed
import FormRow from "@citizenm/form/components/FormRow.vue";

const { thankYouPage } = defineProps<{
  thankYouPage?: RouteLocationRaw;
}>();

const { handleSubmit, state } = useSalesforceForm(
  SALESFORCE_FORM_TYPE.webToLead,
  thankYouPage,
);
const { t } = useI18n();

const validationSchema = toTypedSchema(
  object({
    first_name: string({
      required_error: t("website.form.requiredValue"),
    }),
    last_name: string({
      required_error: t("website.form.requiredValue"),
    }),
    email: string({
      required_error: t("website.form.requiredValue"),
    }).email(t("website.form.error.email_invalid")),
    phone: string({
      required_error: t("website.form.requiredValue"),
    }),
    company: string({
      required_error: t("website.form.requiredValue"),
    }),
    Expected_Volume__c: string({
      required_error: t("website.form.requiredValue"),
    }),
    Booking_Channel__c: string({
      required_error: t("website.form.requiredValue"),
    }),
    Destinations__c: string({
      required_error: t("website.form.requiredValue"),
    }),
    description: string().optional(),
    lead_source: string().default("Web-To-Lead (Sales Form)"),
    Lead_origin__c: string().default("Web-To-Lead"),
  }),
);

const expectedVolumeOptions = [
  {
    label: t("website.form.sales.expected_volume.option_1"),
    value: t("website.form.sales.expected_volume.option_1"),
  },
  {
    label: t("website.form.sales.expected_volume.option_2"),
    value: t("website.form.sales.expected_volume.option_2"),
  },
  {
    label: t("website.form.sales.expected_volume.option_3"),
    value: t("website.form.sales.expected_volume.option_3"),
  },
];

const bookingChannelOptions = [
  {
    label: t("website.form.sales.booking_channel.option_1"),
    value: t("website.form.sales.booking_channel.option_1"),
  },
  {
    label: t("website.form.sales.booking_channel.option_2"),
    value: t("website.form.sales.booking_channel.option_2"),
  },
  {
    label: t("website.form.sales.booking_channel.option_3"),
    value: t("website.form.sales.booking_channel.option_3"),
  },
];

const destinationOptions = [
  {
    label: t("website.form.sales.destinations.option_1"),
    value: t("website.form.sales.destinations.option_1"),
  },
  {
    label: t("website.form.sales.destinations.option_2"),
    value: t("website.form.sales.destinations.option_2"),
  },
  {
    label: t("website.form.sales.destinations.option_3"),
    value: t("website.form.sales.destinations.option_3"),
  },
];
</script>

<template>
  <BaseForm
    :state="state"
    :validation-schema="validationSchema"
    @submit="handleSubmit"
  >
    <FormRow template="1fr 1fr">
      <FormControl :label="t('website.form.firstname')" name="first_name">
        <FormText />
      </FormControl>
      <FormControl :label="t('website.form.lastname')" name="last_name">
        <FormText />
      </FormControl>
    </FormRow>
    <FormRow template="1fr 1fr">
      <FormControl :label="t('website.form.email')" name="email">
        <FormText />
      </FormControl>
      <FormControl :label="t('website.form.phone')" name="phone">
        <FormText />
      </FormControl>
    </FormRow>
    <FormRow template="1fr 1fr">
      <FormControl :label="t('website.form.company')" name="company">
        <FormText />
      </FormControl>
    </FormRow>
    <FormRow template="1fr 1fr">
      <FormControl
        :label="t('website.form.sales.expected_volume.label')"
        name="Expected_Volume__c"
      >
        <FormSelect
          :options="expectedVolumeOptions"
          :placeholder="t('website.form.sales.expected_volume.placeholder')"
        />
      </FormControl>
      <FormControl
        :label="t('website.form.sales.booking_channel.label')"
        name="Booking_Channel__c"
      >
        <FormSelect
          :options="bookingChannelOptions"
          :placeholder="t('website.form.sales.booking_channel.placeholder')"
        />
      </FormControl>
    </FormRow>
    <FormRow template="1fr 1fr">
      <FormControl
        :label="t('website.form.sales.destinations.label')"
        name="Destinations__c"
      >
        <FormSelect
          :options="destinationOptions"
          :placeholder="t('website.form.sales.destinations.placeholder')"
        />
      </FormControl>
    </FormRow>
    <FormRow>
      <FormControl
        :label="t('website.form.sales.description.label')"
        name="description"
      >
        <FormTextarea auto-resize />
      </FormControl>
    </FormRow>
  </BaseForm>
</template>
